import dayjs from 'dayjs';

export function parseUploadDate(value) {
  if (value == null || value === '') return null;
  let date;
  try {
    if (typeof value.toDate === 'function') {
      date = dayjs(value.toDate());
    } else if (typeof value.seconds === 'number') {
      date = dayjs(value.seconds * 1000 + (value.nanoseconds || 0) / 1000000);
    } else {
      date = dayjs(value);
    }
  } catch {
    return null;
  }
  return date.isValid() ? date : null;
}

export function formatUploadDate(value) {
  return parseUploadDate(value)?.format('YYYY-MM-DD hh:mm A') || 'No upload date';
}

export function uploadDateMillis(value) {
  return parseUploadDate(value)?.valueOf() ?? 0;
}
